import { CustomSchedule, DEFAULT_CUSTOM_SCHEDULE_VALUE } from '../../types/settings'
import { ISettingsAdapter, ISettingsAdapterArgs, SettingsAdapter } from './settingsAdapter'

export type ICustomScheduleAdapterArgs = Omit<
  ISettingsAdapterArgs<Record<string, any>, CustomSchedule, CustomSchedule>,
  'toUiValue' | 'toRawValue'
>

export const CustomScheduleAdapter = ({
  inputName,
  variable,
  type,
  defaultRawValue,
  initialUiValue,
  skipFormPopulateOnLoad,
  shouldUseRawValue,
  shouldTreatAsUnset,
  schema
}: ICustomScheduleAdapterArgs): ISettingsAdapter<Record<string, any>, CustomSchedule, CustomSchedule> => {
  const toUiValue = (rawValue: Record<string, any>): CustomSchedule => {
    const customSchedule: CustomSchedule = DEFAULT_CUSTOM_SCHEDULE_VALUE()
    if (rawValue) {
      Object.entries(rawValue).forEach(([key, val]) => {
        if (Array.isArray(val)) {
          if (['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'].includes(key)) {
            const valObj: Record<number, true> = {}
            val.forEach(v => {
              valObj[v] = true
            })
            customSchedule[key as keyof CustomSchedule] = valObj
          }
        }
      })
    }
    return customSchedule
  }

  const toRawValue = (value: CustomSchedule): any => {
    const rawValue: Record<string, any> = {}
    Object.entries(value).forEach(([key, val]) => {
      rawValue[key] = Object.keys(val)
        .map(v => {
          if (v) {
            return Number(v)
          }
          return null
        })
        .filter(v => v !== null)
    })
    return rawValue
  }

  return SettingsAdapter<Record<string, any>, CustomSchedule, CustomSchedule>({
    inputName,
    variable,
    type,
    defaultRawValue,
    initialUiValue,
    toUiValue,
    toRawValue,
    skipFormPopulateOnLoad,
    shouldUseRawValue,
    shouldTreatAsUnset,
    schema
  })
}
